module.exports = __webpack_public_path__ + "static/media/sustainable_desktop.85c4b627.jpg";